module.exports = __webpack_public_path__ + "static/media/articulos.a56495a9.jpeg";